import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export const AVAILABILITY = {
  "In Atelier": "text-brass border-brass/40",
  Unavailable: "text-bone-muted border-bone/15",
  Reserved: "text-bone-dim border-bone/25",
  Sold: "text-bone-muted border-bone/15",
};

export const artText = (art, field, lang) =>
  lang === "en" && art[`${field}_en`] ? art[`${field}_en`] : art[field];
